import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import BackLink from '../future-packages/back-link/BackLink';
import { getAutopayDetails } from '../../ducks/selectors';
import {
  MyCarsContentWrapper,
  AutopayTermsWrapper,
} from './AutopayTerms.styles';
import AutopayTermsCard from './autopay-terms-card/AutopayTermsCard';

const AutopayTerms = () => {
  const { id: vehicleId }: any = useParams();
  const history = useHistory();
  const autoPayDetails = useSelector(getAutopayDetails);
  // Redirect to Setup Auto pay page on refresh
  if (!autoPayDetails) {
    history.push(`/loan-detail/set-up-autopay/${vehicleId}`);
    return null;
  }
  return (
    <AutopayTermsWrapper>
      <MyCarsContentWrapper>
        <BackLink
          backLinkTrackEvent="confirm_auto_pay_cancel_button_tap"
          backLinkText="Back to Autopay"
          backLinkRoute={`/loan-detail/set-up-autopay/${vehicleId}`}
        />
        <AutopayTermsCard vehicleId={vehicleId} />
      </MyCarsContentWrapper>
    </AutopayTermsWrapper>
  );
};

export default AutopayTerms;
